<div class="row">
  <ng-container *ngIf="auctions$ | async as auctions; else loadingRef">
    <ng-container *ngIf="sortedAuctions.length; else noAuctions">
      <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.auction.sortbar'">
        <fgbcl-sort-bar
          class="row w-100"
          [sortBarOptions]="sortBarOptions"
          [itemList]="sortedAuctions"
          [displayDefaultSort]="true"
          (defaultSortAction)="resetOrder()"
        ></fgbcl-sort-bar>
      </ng-container>
      <div *ngFor="let auction of sortedAuctions" class="col-lg-4 col-6">
        <div class="loyalty-item-container">
          <fgbcl-auction-panel [auctionItem]="auction" [featuredIcon]="featuredIcon"></fgbcl-auction-panel>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- No results -->
<ng-template #noAuctions>
  <div class="rewards-placholder">
    <div class="no-items no-results-placeholder-div">
      <div
        class="svg svg-info vs-svg ms-auto me-auto"
        fgbAnimateSvg
        [inlineSVG]="'assets/images/placeholders/Auctions.svg'"
      ></div>
      <div class="no-results-placeholder">{{ 'auction.placeholder.description' | translate }}</div>
    </div>
  </div>
</ng-template>

<!-- Loading -->
<ng-template #loadingRef>
  <div class="w-100">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
